export const formSchema = {
  title: "",
  country: "",
  state: "",
  city: "",
  zipcode: 0,
  is_remote: false,
  role_description: "",
  role_requirements: "",
  role_benefits: "",
  company_industry: "Computer",
  job_function: "",
  skills: [],
  employment_type: "",
  experience: "",
  education: "",
  payment_type: "",
  payment_from: 0,
  payment_to: 0,
  payment_currency: "",
  status: "",
};
export const SEARCHKEYWORDS = [
  "Software",
  "SASS",
  "HTML5",
  "ReactJs",
  "AngularJs",
  "Bootstrap",
  "JQuery",
  "Django",
  "Python",
  "Redux",
  "Graphic Designing",
  "CSS",
  "Wordpress",
  "PHP",
  "SQL",
  "AJAX",
  "Java"
];
export const job_title_limit_length = 64;

export const can_not_be_null = "This field can not be empty";

export const COMPANY_INDUSTRY_CHOICES = [
  {
    key: "Computer",
    value: "Computer",
  },
  {
    key: "Hospitality",
    value: "Hospitality",
  },
  {
    key: "Information",
    value: "Information",
  },
  {
    key: "Music",
    value: "Music",
  },
  {
    key: "other",
    value: "other",
  },
];

export const EDUCATION = [
  {
    key: "Bachelors",
    value: "Bachelors",
  },
  
  {
    key: "Diploma",
    value: "Diploma",
  },
  {
    key: "Doctorate",
    value: "Doctorate",
  },
  {
    key: "Post Doctorate",
    value: "Post Doctorate",
  },
  {
    key: "Masters",
    value: "Masters",
  },

];

export const EMPLOYMENT_TYPE = [
  {
    key: "Full Time",
    value: "full_time",
  },
  {
    key: "Part Time",
    value: "part_time",
  },
  {
    key: "Contract",
    value: "contract",
  },

  {
    key: "Contract to Hire",
    value: "contract_to_hire",
  },
];

export const JOB_FUNCTION = [
  {
    key: "Backend Developer",
    value: "Backend Developer",
  },
  {
    key: "Frontend Developer",
    value: "Frontend Developer",
  },
  {
    key: "Java Developer",
    value: "Java Developer",
  },
  {
    key: "React Native Developer",
    value: "React Native Developer",
  },
  {
    key: "UI/UX Designer",
    value: "UI/UX Designer",
  },
  {
    key: "React",
    value: "React",
  },
];

export const CURRENCY_CHOICES = [
  {
    key: "India (INR)",
    value: "inr",
  },
  {
    key: "United State of America (USD)",
    value: "usd",
  },
  {
    key: "European Union (EURO)",
    value: "euro",
  },
  {
    key: "Australia (AUD)",
    value: "aud",
  },
  {
    key: "Japan (JPY)",
    value: "jpy",
  },
  {
    key: "Great British Pound (GBP)",
    value: "gbp",
  },
  {
    key: "Swiss Franc (CHF)",
    value: "chf",
  },
  {
    key: "Canadian Dollar (CAD)",
    value: "cad",
  },
  {
    key: "South African Rand (ZAR)",
    value: "zar",
  },
];

export const EXPERIENCE = [
  {
    key: "0 To 3 Years",
    value: "0_to_3_years",
  },
  {
    key: "4 To 7 Years",
    value: "4_to_7_years",
  },
  {
    key: "8 To 10 Years",
    value: "8_to_10_years",
  },
  {
    key: "11 To 13 Years",
    value: "11_to_13_years",
  },
  {
    key: "14 To 17 Years",
    value: "14_to_17_years",
  },
  {
    key: "18 To 20 Years",
    value: "18_to_20_years",
  },
  {
    key: "Above 20 Years",
    value: "above_20_years",
  },
];
